import React from "react";
import Banner from '../../components/Home/Banner/Banner'
import BestSale from "../../components/Home/BestSale/BestSale";
// import Category from "../../components/Home/Category/Category";
import Deals from "../../components/Home/Deals/Deals";
import FeatureProducts from "../../components/Home/FeatureProducts/FeatureProducts";
import Footer from "../../components/Common/Footer/Footer";
import Header from "../../components/Common/Header/Header";
// import MostLiked from "../../components/Home/MostLiked/MostLiked";
import NewCollection from "../../components/Home/NewCollection/NewCollection";
import Offer from "../../components/Home/Offer/Offer";
import OurFeatures from "../../components/Home/OurFeatures/OurFeatures";
import SubHeader from "../../components/Common/SubHeader/SubHeader";
import Subscription from "../../components/Common/Subscription/Subscription";

const Home = () => {
  return (
    <div>
      <SubHeader/>
      <Header />
      <Banner/>

      <FeatureProducts/>
      {/* <Category/> */}
      <NewCollection/>
      <Offer/>
      <Deals/>
      <BestSale/>
      {/* <MostLiked/>  */}
      <Subscription/>
      <OurFeatures/>
      <Footer />
    </div>
  );
};

export default Home;
